export default "__VITE_ASSET__2bb7be24__"